// extracted by mini-css-extract-plugin
export default {"navLinksContainer":"styles_navLinksContainer__iPkjh","mainLink":"styles_mainLink__XUF2s","landingDrawer":"styles_landingDrawer__FW0eC","primaryColor":"styles_primaryColor__zHgVp"};